






import Vue from 'vue';
import { mapGetters, mapState, mapMutations } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    model: {
        prop: 'value',
        event: 'change'
    },
    computed: {
        ...mapGetters('esb', { getMod: 'get', lists: 'list' }),
        ...mapState('esb', { modIsPending: 'isFindPending' })
    },
    methods: {
        ...mapMutations('bh-flow', { hideProperties: 'hide' })
    }
})
export default class BhFlow extends Vue {
    @Prop({ default() { return []; } })
    value!: any[]

    getMod: any;
    hideProperties: any;

    public getValueHolder(data: any, info: any[]) {
        let ret = this.value;
        info.map((i, index) => {
            ret = ret[i];
        });
        return ret;
    }

    public onDropItem(data: any) {
        let ret = this.value;
        data.info.map((i: any, index: number) => {
            if(index === (data.info.length-1)) {
                if(data.data.type === 'new') {
                    const modInfo = this.getMod(data.data.module);
                    const newEntry: any = {
                        module: data.data.module,
                        name: data.data.name,
                        props: {}
                    };
                    if(modInfo.nested) {
                        newEntry.child = [];
                    }
                    if(i === 'child') {
                        ret[i].push([newEntry]);
                    } else {
                        ret.splice(i + 1, 0, newEntry);
                    }
                } else if(data.data.type === 'move') {
                    const t = JSON.stringify(data.info.slice(0,-1));
                    const d = JSON.stringify(data.data.location.slice(0,-1));
                    this.onDropItem({ data: { type: 'remove' }, info: data.data.location, event: data.event });
                    if(i === 'child') {
                        ret[i].push([data.data.mod]);
                    } else {
                        ret.splice(i + (t === d && data.info[data.info.length-1] > data.data.location[data.info.length-1] ? 0 : 1), 0, data.data.mod);
                    }
                } else if(data.data.type === 'remove') {
                    if(ret.length === 1) {
                        const target = this.getValueHolder(this.value, data.info.slice(0,-2));
                        target.splice(data.info.splice(-2,1)[0], 1);
                    } else {
                        ret.splice(i, 1);
                    }
                    this.hideProperties();
                }
            } else {
                ret = ret[i];
            }
        });
    }

}
